/**
 *
 * WARNING : fichier généré par cli, ne pas le modifier directement
 *
 */
import * as R from 'ramda';
import { useQuery } from '@apollo/client';
import GetSimulationCompanyDepartmentsQuery from '../graphql/queries/GetSimulationCompanyDepartmentsQuery.js';

const useGetSimulationCompanyDepartmentsQuery = (args) => {
  const { data, error, loading, refetch } = useQuery(GetSimulationCompanyDepartmentsQuery, args);

  return {
    error,
    loading,
    refetch,
    getSimulationCompanyDepartments: R.omit(['__typename'], data?.getSimulationCompanyDepartments_simulation_company || {})
  };
};

export default useGetSimulationCompanyDepartmentsQuery;
